import { AccountNavButton } from "../../../Views/Account/Components/AccountNavItem";
import { ReactComponent as LogoutIcon } from "@icons/logout.svg";
import { useTranslation } from "react-i18next";

const LogoutButton = ({ label, handleLogout }: { label: string; handleLogout: () => void }) => {
  return (
    <button className="w-full h-full p-2 text-left hover:bg-silver" aria-label={label} onClick={() => handleLogout()}>
      <span>{label}</span>
    </button>
  );
};

const LogoutNavButton = ({ label, handleLogout }: { label: string; handleLogout: () => void }) => {
  return <AccountNavButton onClick={handleLogout} text={label} Icon={LogoutIcon} bottomLine />;
};

export const Logout = ({ type, handleLogout }: { handleLogout: () => void; type?: "default" | "nav" }) => {
  const { t } = useTranslation();
  const label = t("navigation.userAccountMenu.logout");
  const navLabel = t("account.logOut");

  switch (type) {
    case "nav":
      return <LogoutNavButton label={navLabel} handleLogout={handleLogout} />;
    case "default":
    default:
      return <LogoutButton label={label} handleLogout={handleLogout} />;
  }
};
